import { proxy } from 'valtio';

/** Lets applet UI ask AppletGuard to show the upgrade modal again after it was dismissed. */
export const appletUpgradeModalStore = proxy({
  openRequestVersion: 0,
});

export function requestAppletUpgradeModal() {
  appletUpgradeModalStore.openRequestVersion += 1;
}
